module.exports = __webpack_public_path__ + "img/2_84.05561e42.png";